import { AxiosResponse } from 'axios';
import api from './Api'

export const getPremiumMembership = (): Promise<AxiosResponse<IPremiumMembership, any>> => {
    return api.get(`/premium/membership`);
}